module.exports = __webpack_public_path__ + "static/media/component-3.f8537828.svg";